(function() {
  function domReady(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
    } else {
      callback();
    }
  }

  function isMobileInteraction() {
    return (
      (window.matchMedia && window.matchMedia('(max-width: 1023px)').matches) ||
      (window.matchMedia && window.matchMedia('(hover: none)').matches) ||
      ('ontouchstart' in window) ||
      (navigator.maxTouchPoints && navigator.maxTouchPoints > 0)
    );
  }

  function addSpinnerStyles() {
    if (document.getElementById('__7ml_spinner_styles')) return;
    var spinnerStyle = document.createElement('style');
    spinnerStyle.id = '__7ml_spinner_styles';
    spinnerStyle.textContent = '\n      @keyframes __copilot_spin{ to{ transform: rotate(360deg); } }\n      .__copilot_spinner{ display:inline-block; width:16px; height:16px; border:2px solid rgba(0,0,0,0.12); border-top-color:#000; border-radius:50%; animation:__copilot_spin 1s linear infinite; margin-right:8px; vertical-align:middle; }\n    ';
    document.head.appendChild(spinnerStyle);
  }

  function setupLoadingHelpers() {
    window.__7ml_setButtonLoading = function(btn, text) {
      if (!btn) return;
      try {
        if (!btn.dataset._origHtml) btn.dataset._origHtml = btn.innerHTML;
        btn.disabled = true;
        btn.setAttribute('aria-busy', 'true');
        btn.innerHTML = '<span class="__copilot_spinner" aria-hidden="true"></span>' + (text || 'Adding to cart');
      } catch (e) {
        // ignore
      }
    };

    window.__7ml_clearButtonLoading = function(btn) {
      if (!btn) return;
      try {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (btn.dataset._origHtml) {
          btn.innerHTML = btn.dataset._origHtml;
          delete btn.dataset._origHtml;
        }
      } catch (e) {
        // ignore
      }
    };
  }

  function initSection(sectionRoot) {
    if (!sectionRoot) return;
    var sectionId = sectionRoot.id.replace(/^offers_section-/, '');
    if (!sectionId) return;

    addSpinnerStyles();
    setupLoadingHelpers();

    var mobileImage = sectionRoot.querySelector('#mobile_offer_image-' + sectionId);
    var mobileTitle = sectionRoot.querySelector('#mobile_offer_title-' + sectionId);
    var mobileCheckout = sectionRoot.querySelector('#mobile_checkout-' + sectionId);
    var popupOverlay = sectionRoot.querySelector('#promo_popup_overlay-' + sectionId);
    var popupBody = sectionRoot.querySelector('#promo_popup_body-' + sectionId);
    var popupClose = sectionRoot.querySelector('#promo_popup_close-' + sectionId);
    var activeLoopId = null;
    var clickCounters = {};
    var clickTimeouts = {};

    function openPromoPopup(message) {
      if (!popupOverlay || !popupBody) return;
      popupBody.textContent = message || '';
      popupOverlay.classList.add('is-open');
      popupOverlay.setAttribute('aria-hidden', 'false');
    }

    function closePromoPopup() {
      if (!popupOverlay) return;
      popupOverlay.classList.remove('is-open');
      popupOverlay.setAttribute('aria-hidden', 'true');
    }

    function makePrefix(loopId) { return sectionId + '-' + loopId; }

    function setActiveOffer(loopId) {
      activeLoopId = loopId;
      var offerEl = sectionRoot.querySelector('.product-offer[data-loop="' + loopId + '"]');
      if (!offerEl) return;
      sectionRoot.querySelectorAll('.product-offer.is-active').forEach(function(el) {
        el.classList.remove('is-active');
      });
      offerEl.classList.add('is-active');
      var title = offerEl.getAttribute('data-title') || '';
      if (mobileTitle && title) mobileTitle.textContent = title;
    }

    function closeAllDropouts() {
      sectionRoot.querySelectorAll('.freq_dropp .dropout').forEach(function(d) {
        d.style.display = 'none';
      });
    }

    function clearOfferSelectionTimer(loopId) {
      if (!clickTimeouts[loopId]) return;
      clearTimeout(clickTimeouts[loopId]);
      delete clickTimeouts[loopId];
    }

    function resetOfferSelection(loopId) {
      var offerEl = sectionRoot.querySelector('.product-offer[data-loop="' + loopId + '"]');
      if (offerEl) offerEl.classList.remove('is-selected');
      clickCounters[loopId] = 0;
      clearOfferSelectionTimer(loopId);
    }

    sectionRoot.querySelectorAll('.option').forEach(function(radio) {
      radio.addEventListener('change', function() {
        var type = radio.getAttribute('data-type');
        var loopId = radio.getAttribute('data-id');
        var prefix = makePrefix(loopId);

        setActiveOffer(loopId);

        if (isMobileInteraction()) {
          sectionRoot.querySelectorAll('.product-offer[data-loop]').forEach(function(offer) {
            var otherLoop = offer.getAttribute('data-loop');
            if (otherLoop === loopId) return;

            offer.querySelectorAll('.option').forEach(function(otherRadio) {
              otherRadio.checked = false;
            });

            var otherPrefix = makePrefix(otherLoop);
            var otherFreqDrop = sectionRoot.querySelector('#freq_drop-' + otherPrefix);
            var otherDropout = sectionRoot.querySelector('#dropout_' + otherPrefix);
            var otherSellPlanEl = sectionRoot.querySelector('#sell_plan-' + otherPrefix);
            var otherIntervalEl = sectionRoot.querySelector('#interval_select-' + otherPrefix);
            var otherOptHidden = sectionRoot.querySelector('input[name="option_' + otherLoop + '"]');
            var otherInOpt = sectionRoot.querySelector('#in_opt-' + otherPrefix);

            if (otherFreqDrop) otherFreqDrop.style.display = 'none';
            if (otherDropout) otherDropout.style.display = 'none';
            if (otherOptHidden) otherOptHidden.value = 'add';
            if (otherInOpt) otherInOpt.value = 0;
            if (otherSellPlanEl) otherSellPlanEl.value = '';
            if (otherIntervalEl) otherIntervalEl.value = '';
          });
        }

        var freqDrop = sectionRoot.querySelector('#freq_drop-' + prefix);
        var dropout = sectionRoot.querySelector('#dropout_' + prefix);
        var sellPlanEl = sectionRoot.querySelector('#sell_plan-' + prefix);
        var intervalEl = sectionRoot.querySelector('#interval_select-' + prefix);
        var optHidden = sectionRoot.querySelector('input[name="option_' + loopId + '"]');
        var inOpt = sectionRoot.querySelector('#in_opt-' + prefix);

        if (type === 'sub') {
          if (freqDrop) freqDrop.style.display = 'block';
          if (dropout) dropout.style.display = 'none';
          if (optHidden) optHidden.value = 'subscribe';
          if (inOpt) inOpt.value = 1;
          var freqSel = sectionRoot.querySelector('#freq_' + prefix);
          if (sellPlanEl && freqSel) sellPlanEl.value = freqSel.getAttribute('data-id') || '';
          if (intervalEl) intervalEl.value = '1';
        } else {
          if (freqDrop) freqDrop.style.display = 'none';
          if (dropout) dropout.style.display = 'none';
          if (optHidden) optHidden.value = 'add';
          if (inOpt) inOpt.value = 0;
          if (sellPlanEl) sellPlanEl.value = '';
          if (intervalEl) intervalEl.value = '';
        }
      });
    });

    sectionRoot.querySelectorAll('.freq_selected').forEach(function(freqSel) {
      freqSel.addEventListener('click', function(e) {
        e.stopPropagation();
        var loopId = freqSel.getAttribute('data-rel');
        var prefix = makePrefix(loopId);
        var dropout = sectionRoot.querySelector('#dropout_' + prefix);
        if (!dropout) return;

        setActiveOffer(loopId);
        sectionRoot.querySelectorAll('.freq_dropp .dropout').forEach(function(d) {
          if (d !== dropout) d.style.display = 'none';
        });
        dropout.style.display = (dropout.style.display === 'block') ? 'none' : 'block';

        var sellPlanEl = sectionRoot.querySelector('#sell_plan-' + prefix);
        var inOpt = sectionRoot.querySelector('#in_opt-' + prefix);
        var optHidden = sectionRoot.querySelector('input[name="option_' + loopId + '"]');
        if (optHidden) optHidden.value = 'subscribe';
        if (inOpt) inOpt.value = 1;
        if (sellPlanEl) sellPlanEl.value = freqSel.getAttribute('data-id') || '';
      });
    });

    sectionRoot.querySelectorAll('.freq_opt').forEach(function(opt) {
      opt.addEventListener('click', function() {
        var loopId = opt.getAttribute('data-loop');
        var prefix = makePrefix(loopId);
        var interval = opt.getAttribute('data-rel');
        var planId = opt.getAttribute('data-id');
        var labelTxt = opt.querySelector('b') ? opt.querySelector('b').textContent : '';

        setActiveOffer(loopId);

        var intervalEl = sectionRoot.querySelector('#interval_select-' + prefix);
        var sellPlanEl = sectionRoot.querySelector('#sell_plan-' + prefix);
        var labelEl = sectionRoot.querySelector('.b-' + prefix);
        var dropout = sectionRoot.querySelector('#dropout_' + prefix);

        if (intervalEl) intervalEl.value = interval || '';
        if (sellPlanEl) sellPlanEl.value = planId || '';
        if (labelEl) labelEl.textContent = labelTxt || '30 days';
        if (dropout) dropout.style.display = 'none';
      });
    });

    sectionRoot.querySelectorAll('.continue-button[data-id]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var loopId = btn.getAttribute('data-id');
        var prefix = makePrefix(loopId);
        var payload = {
          id: (sectionRoot.querySelector('#product_idd-' + prefix) || {}).value || '',
          quantity: (sectionRoot.querySelector('#in_quan-' + prefix) || {}).value || '1',
          selling_plan: (sectionRoot.querySelector('#sell_plan-' + prefix) || {}).value || '',
          subs_type: (sectionRoot.querySelector('#in_opt-' + prefix) || {}).value || '0',
          subs_interval: (sectionRoot.querySelector('#interval_select-' + prefix) || {}).value || ''
        };

        if (window.__7ml_setButtonLoading) window.__7ml_setButtonLoading(btn, 'Adding to cart');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(r) { return r.json(); })
        .then(function() { window.location.href = '/cart'; })
        .catch(function(err) {
          console.error(err);
          if (window.__7ml_clearButtonLoading) window.__7ml_clearButtonLoading(btn);
        });
      });
    });

    sectionRoot.querySelectorAll('.product-name').forEach(function(nameEl) {
      function handleMobileClick() {
        if (!isMobileInteraction()) return false;
        var offerEl = nameEl.closest('.product-offer');
        if (!offerEl) return true;
        var loopId = offerEl.getAttribute('data-loop');
        if (!loopId) return true;

        sectionRoot.querySelectorAll('.product-offer[data-loop]').forEach(function(offer) {
          var otherLoop = offer.getAttribute('data-loop');
          if (otherLoop === loopId) return;
          offer.querySelectorAll('.option').forEach(function(otherRadio) { otherRadio.checked = false; });
          var otherPrefix = makePrefix(otherLoop);
          var otherOptHidden = sectionRoot.querySelector('input[name="option_' + otherLoop + '"]');
          var otherInOpt = sectionRoot.querySelector('#in_opt-' + otherPrefix);
          var otherSellPlanEl = sectionRoot.querySelector('#sell_plan-' + otherPrefix);
          var otherIntervalEl = sectionRoot.querySelector('#interval_select-' + otherPrefix);
          if (otherOptHidden) otherOptHidden.value = 'add';
          if (otherInOpt) otherInOpt.value = 0;
          if (otherSellPlanEl) otherSellPlanEl.value = '';
          if (otherIntervalEl) otherIntervalEl.value = '';
          clickCounters[otherLoop] = 0;
        });

        var addRadio = sectionRoot.querySelector('.option[data-id="' + loopId + '"][data-type="add"]');
        if (addRadio) addRadio.checked = true;
        var prefix = makePrefix(loopId);
        var optHidden = sectionRoot.querySelector('input[name="option_' + loopId + '"]');
        var inOpt = sectionRoot.querySelector('#in_opt-' + prefix);
        if (optHidden) optHidden.value = 'add';
        if (inOpt) inOpt.value = 0;

        setActiveOffer(loopId);

        clickCounters[loopId] = (clickCounters[loopId] || 0) + 1;
        if (clickCounters[loopId] === 1) {
          return true;
        }

        var payload = {
          id: (sectionRoot.querySelector('#product_idd-' + prefix) || {}).value || '',
          quantity: (sectionRoot.querySelector('#in_quan-' + prefix) || {}).value || '1',
          selling_plan: (sectionRoot.querySelector('#sell_plan-' + prefix) || {}).value || '',
          subs_type: (sectionRoot.querySelector('#in_opt-' + prefix) || {}).value || '0',
          subs_interval: (sectionRoot.querySelector('#interval_select-' + prefix) || {}).value || ''
        };

        var offerBtn = sectionRoot.querySelector('.continue-button[data-id="' + loopId + '"]');
        if (window.__7ml_setButtonLoading) window.__7ml_setButtonLoading(offerBtn, 'Adding to cart');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(r) { return r.json(); })
        .then(function() { window.location.href = '/cart'; })
        .catch(function(err) {
          console.error(err);
          if (window.__7ml_clearButtonLoading) window.__7ml_clearButtonLoading(offerBtn);
        })
        .finally(function() {
          clickCounters[loopId] = 0;
        });

        return true;
      }

      nameEl.addEventListener('click', function(e) {
        if (isMobileInteraction()) {
          e.preventDefault();
          handleMobileClick();
        } else {
          var message = nameEl.getAttribute('data-promo') || '';
          if (!message.trim()) return;
          openPromoPopup(message);
        }
      });

      nameEl.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          if (isMobileInteraction()) {
            handleMobileClick();
          } else {
            var message = nameEl.getAttribute('data-promo') || '';
            if (!message.trim()) return;
            openPromoPopup(message);
          }
        }
      });
    });

    if (popupClose) {
      popupClose.addEventListener('click', closePromoPopup);
    }

    if (popupOverlay) {
      popupOverlay.addEventListener('click', function(e) {
        if (e.target === popupOverlay) closePromoPopup();
      });
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closePromoPopup();
    });

    function scrollActiveOfferIntoView() {
      if (!activeLoopId) return;
      var offerEl = sectionRoot.querySelector('.product-offer[data-loop="' + activeLoopId + '"]');
      if (!offerEl) return;

      if (!mobileImage) {
        offerEl.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        return;
      }

      var imageRect = mobileImage.getBoundingClientRect();
      var currentScroll = window.scrollY || window.pageYOffset;
      var keepVisible = Math.max(0, imageRect.height * 0.2);
      var scrollTo = currentScroll + imageRect.bottom - keepVisible;
      if (scrollTo < 0) scrollTo = 0;
      window.scrollTo({ top: scrollTo, behavior: 'smooth' });
    }

    if (mobileImage) {
      mobileImage.addEventListener('click', function() {
        if (!isMobileInteraction()) return;
        if (!activeLoopId) {
          var firstOffer = sectionRoot.querySelector('.product-offer[data-loop]');
          if (firstOffer) activeLoopId = firstOffer.getAttribute('data-loop');
        }
        if (!activeLoopId) return;
        setActiveOffer(activeLoopId);
        scrollActiveOfferIntoView();
      });
    }

    if (mobileCheckout) {
      mobileCheckout.addEventListener('click', function() {
        if (!activeLoopId) {
          var firstOffer = sectionRoot.querySelector('.product-offer[data-loop]');
          if (firstOffer) activeLoopId = firstOffer.getAttribute('data-loop');
        }
        if (!activeLoopId) return;
        var prefix = makePrefix(activeLoopId);
        var payload = {
          id: (sectionRoot.querySelector('#product_idd-' + prefix) || {}).value || '',
          quantity: (sectionRoot.querySelector('#in_quan-' + prefix) || {}).value || '1',
          selling_plan: (sectionRoot.querySelector('#sell_plan-' + prefix) || {}).value || '',
          subs_type: (sectionRoot.querySelector('#in_opt-' + prefix) || {}).value || '0',
          subs_interval: (sectionRoot.querySelector('#interval_select-' + prefix) || {}).value || ''
        };

        if (window.__7ml_setButtonLoading) window.__7ml_setButtonLoading(mobileCheckout, 'Adding to cart');

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(r) { return r.json(); })
        .then(function() { window.location.href = '/cart'; })
        .catch(function(err) {
          console.error(err);
          if (window.__7ml_clearButtonLoading) window.__7ml_clearButtonLoading(mobileCheckout);
        });
      });
    }

    document.addEventListener('click', function(e) {
      if (!sectionRoot.contains(e.target)) return;
      if (!e.target.closest('.freq_dropp')) closeAllDropouts();
    });

    var firstOfferInit = sectionRoot.querySelector('.product-offer[data-loop]');
    if (firstOfferInit) setActiveOffer(firstOfferInit.getAttribute('data-loop'));

    if (isMobileInteraction()) {
      var firstLoop = firstOfferInit ? firstOfferInit.getAttribute('data-loop') : null;
      if (firstLoop) {
        sectionRoot.querySelectorAll('.option[data-type="add"]').forEach(function(radio) {
          if (radio.getAttribute('data-id') !== firstLoop) {
            radio.checked = false;
          }
        });
        var firstRadio = sectionRoot.querySelector('.option[data-type="add"][data-id="' + firstLoop + '"]');
        if (firstRadio) firstRadio.checked = true;
      }
    }
  }

  domReady(function() {
    document.querySelectorAll('[id^="offers_section-"]').forEach(function(sectionRoot) {
      if (sectionRoot.querySelector('.product-offers-section')) {
        initSection(sectionRoot);
      }
    });
  });
})();
